import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import AppRouter from './router'
import { getStore, getHistory } from './store'
import { theme } from './theme'
import './App.css'

const dwelletTheme = createMuiTheme(theme) // custom theme here

const App = () => {
  return (
    <Provider store={getStore()}>
      <ToastContainer />
      <MuiThemeProvider theme={dwelletTheme}>
        <AppRouter history={getHistory()} />
      </MuiThemeProvider>
    </Provider>
  )
}

export default App
